import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Space, message } from 'antd';
//import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
//import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import { useAuth0 } from '@auth0/auth0-react';

interface Empresa {
  id: number;
  razon: string;
  direccion: string;
  localidad: string;
  provincia: string;
}

interface Sucursal {
  id: number;
  descripcion: string;
  localidad: string;
  provincia: string;
}

interface Comprobante {
  id: number;
  nro_comprobante: string;
  fecha_emision: string;
  padron: string;
  tipo: string;
  observacion: string;
  alta: number;
}

interface Movimientos {
  id: number;
  comprobante_id: number;
  insumo: string;
  cantidad: number;
  precio_unitario: number;
  subtotal: number;
  iva: number;
  iinterno: number;
  fecha_entrega: string;
}

interface FormasPago {
  id: number;
  comprobante_id: number;
  fecha_pago: string;
  importe: number;
//  vencimiento: string;
}

interface Autorizacion {
  fecha: string;
  identificacion: string;
  mail: string;
}

interface DataState {
  empresa: Empresa;
  sucursal: Sucursal;
  comprobante: Comprobante[];
  movimientos: Movimientos[];
  formasPago: FormasPago[];
  autorizacion: Autorizacion;
}

const ImprimirOCompra: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const {getAccessTokenSilently ,isLoading} = useAuth0();
  const { user } = useAuth0();
  const empresa = user?.id_empresa;
  const sucursal = user?.id_sucursal;
  const [data, setData] = useState<DataState>({
    empresa: {} as Empresa,
    sucursal: {} as Sucursal,
    comprobante: [],
    movimientos: [],
    formasPago: [],
    autorizacion: {} as Autorizacion
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (isLoading) return;
      setLoading(true);
      try {
        const token = await getAccessTokenSilently();
        const ruta = `${process.env.REACT_APP_INSUMOS_URL}/comprobante_ocompra/${empresa}/${sucursal}/${id}`;
        console.log('ruta', ruta);        
        const response = await fetch(ruta, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const jsonData = await response.json();
        setData(jsonData);
        console.log('xaqui_comprobante_ocompra7',jsonData)
      } catch (error) {
        console.error('Error fetching data:', error);
        message.error('Error al obtener los datos del comprobante');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id,isLoading, getAccessTokenSilently]);

  const exportToPDF = () => {
    const doc = new jsPDF();
    let yEmpresa = 20;  // Para los datos de empresa
    let yTitulo = 20;   // Para el título y fechas
    const lineHeight = 7;
    const pageWidth = doc.internal.pageSize.width;
    const leftMargin = 14;
    const rightMargin = pageWidth - 14;

    const empresa = data.empresa;
    if (empresa) {
      // Columna izquierda: Datos de empresa
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text(empresa.razon || '', leftMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Resto de datos de empresa debajo de razón
      doc.setFont('helvetica', 'normal');
      doc.text(empresa.direccion || '', leftMargin, yEmpresa);
      yEmpresa += lineHeight;
      doc.text(empresa.localidad || '', leftMargin, yEmpresa);
      yEmpresa += lineHeight;
      doc.text(empresa.provincia || '', leftMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Línea debajo de provincia
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Datos de sucursal centrados
      const sucursal = data.sucursal;
      if (sucursal) {
        // Construir el texto completo de sucursal
        doc.setFont('helvetica', 'bold');
        const labelSucursal = 'Sucursal: ';
        
        doc.setFont('helvetica', 'normal');
        const direccionText = sucursal.descripcion || '';
        const ubicacionText = `${sucursal.localidad || ''} - ${sucursal.provincia || ''}`;
        const textoCompleto = `${labelSucursal}${direccionText}, ${ubicacionText}`;

        // Centrar todo el texto
        doc.text(textoCompleto, pageWidth/2, yEmpresa, { align: 'center' });
        yEmpresa += lineHeight;
      }

      // Segunda línea debajo de los datos de sucursal
      doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);
      yEmpresa += lineHeight * 1.5;

      // Datos del proveedor
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      const DatoProveedor = `PROVEEDOR: ${data.comprobante[0]?.padron || ''}`;
      doc.text(DatoProveedor, leftMargin, yEmpresa);
      yEmpresa += lineHeight * 1.5;

      // Datos del proveedor en vertical con labels
      doc.setFont('helvetica', 'normal');
      //const labelWidth = 25;

      // Razón Social
      //doc.text('Razón Social:', leftMargin, yEmpresa);
      //doc.text(`${data.comprobante[0]?.padron || ''}`, leftMargin + labelWidth, yEmpresa);
      //yEmpresa += lineHeight;

      // Dirección
      //doc.text('Dirección:', leftMargin, yEmpresa);
      //doc.text(`${data.comprobante[0]?.direccion || ''}`, leftMargin + labelWidth, yEmpresa);
      //yEmpresa += lineHeight;

      // Localidad
      //doc.text('Localidad:', leftMargin, yEmpresa);
      //doc.text(`${data.comprobante[0]?.localidad || ''}`, leftMargin + labelWidth, yEmpresa);
      //yEmpresa += lineHeight;

      // Provincia
      //doc.text('Provincia:', leftMargin, yEmpresa);
      //doc.text(`${data.comprobante[0]?.provincia || ''}`, leftMargin + labelWidth, yEmpresa);
      //yEmpresa += lineHeight;

      // Columna central: ORDEN COMPRA
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text('ORDEN DE COMPRA', pageWidth/2, yTitulo, { align: 'center' });
      
      // Nº de orden en línea separada
      doc.setFontSize(14);
      doc.text(`Nº ${data.comprobante[0]?.nro_comprobante || ''}`, pageWidth/2, yTitulo + lineHeight, { align: 'center' });
      yTitulo += lineHeight * 2; // Aumentar el espacio después del título

      // Columna derecha: Fechas
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      const fechaGeneracion = new Date().toLocaleDateString('es-AR');
      doc.text(`Fecha Generación: ${fechaGeneracion}`, rightMargin, 20, { align: 'right' });
      
      const fechaEmision = data.comprobante[0]?.fecha_emision || '';
      doc.text(`Fecha Emisión: ${fechaEmision}`, rightMargin, 20 + lineHeight, { align: 'right' });

      // Reiniciar posición Y para el resto del contenido
    //  let y = Math.max(yEmpresa, yTitulo) + lineHeight * 2;
      
      // Datos del comprobante
//      doc.setFontSize(12);
//      doc.text(`Proveedor: ${data.comprobante[0]?.padron || 'Sin proveedor'}`, leftMargin, y);
//      y += lineHeight * 2;

      // Título de Detalle de Insumos centrado
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('DETALLE DE INSUMOS', pageWidth/2, yEmpresa, { align: 'center' });
      yEmpresa += lineHeight;
      //
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Headers de la grilla
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Detalle Insumos', 14, yEmpresa);
      doc.text('Cantidad', 75, yEmpresa);
      doc.text('Precio Unitario', 110, yEmpresa);
      doc.text('Subtotal', 150, yEmpresa);
      doc.text('Entrega', 180, yEmpresa);
      yEmpresa += lineHeight;

      // Línea debajo de los labels
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Función para formatear números con separador de miles
      const formatNumber = (num: number): string => {
        return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };

      // Función para convertir número a letras
      const numeroALetras = (numero: number): string => {
        const unidades = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
        const decenas = ['', 'DIEZ', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
        const especiales = ['ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISEIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE'];
        const centenas = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];

        const procesarMiles = (n: number): string => {
          if (n === 0) return '';
          let result = '';
          
          // Procesar millones
          const millones = Math.floor(n / 1000000);
          if (millones > 0) {
            if (millones === 1) {
              result += 'UN MILLON ';
            } else {
              result += `${numeroALetras(millones)} MILLONES `;
            }
            n = n % 1000000;
          }

          // Procesar miles
          const miles = Math.floor(n / 1000);
          if (miles > 0) {
            if (miles === 1) {
              result += 'MIL ';
            } else {
              result += `${numeroALetras(miles)} MIL `;
            }
            n = n % 1000;
          }

          // Procesar centenas
          const centena = Math.floor(n / 100);
          if (centena > 0) {
            if (centena === 1 && n % 100 === 0) {
              result += 'CIEN ';
            } else {
              result += `${centenas[centena]} `;
            }
            n = n % 100;
          }

          // Procesar decenas y unidades
          if (n > 0) {
            if (n < 10) {
              result += `${unidades[n]} `;
            } else if (n < 20) {
              result += `${especiales[n - 11]} `;
            } else {
              const decena = Math.floor(n / 10);
              const unidad = n % 10;
              if (unidad === 0) {
                result += `${decenas[decena]} `;
              } else {
                result += `${decenas[decena]} Y ${unidades[unidad]} `;
              }
            }
          }

          return result;
        };

        if (numero === 0) return 'CERO';
        return procesarMiles(numero);
      };

      // Movimientos con verificación de números
      doc.setFont('helvetica', 'normal');
      let totalGeneral = 0;  // Variable para acumular el total

      data.movimientos.forEach(mov => {
        doc.text(`${mov.insumo}`, 14, yEmpresa);
        doc.text(`${mov.cantidad || 0}`, 86, yEmpresa,{ align: 'right' });
        
        // Precio unitario alineado a la derecha
        const precioText = `$ ${formatNumber(mov.precio_unitario || 0)}`;
        doc.text(precioText, 140, yEmpresa, { align: 'right' });
        
        // Calcular total con verificación de valores undefined
        const subtotal = mov.subtotal || 0;
      //  const iva = mov.iva || 0;
      //  const iinterno = mov.iinterno || 0;
        const total = subtotal ;
        totalGeneral += total;
        
        // Subtotal alineado a la derecha
        const totalText = `$ ${formatNumber(total)}`;
        doc.text(totalText, 170, yEmpresa, { align: 'right' });
        
        doc.text(mov.fecha_entrega || '', 180, yEmpresa);
        yEmpresa += lineHeight;
      });

      // Línea después de la grilla de insumos
      doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Total General alineado a la derecha
      doc.setFont('helvetica', 'bold');
      doc.text('Total:', 120, yEmpresa);
      const totalGeneralText = `$ ${formatNumber(totalGeneral)}`;
      doc.text(totalGeneralText, 170, yEmpresa, { align: 'right' });
      yEmpresa += lineHeight * 2;  // Espacio adicional antes del texto en letras

      // Total en letras dividido en dos líneas
      const totalEntero = Math.floor(totalGeneral);
      const centavos = Math.round((totalGeneral - totalEntero) * 100);
      const importeEnLetras = numeroALetras(totalEntero).trim();
      
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      
      // Primera línea alineada al margen izquierdo
      doc.text('Son Pesos:', leftMargin, yEmpresa);
      yEmpresa += lineHeight;
      
      // Segunda línea (importe en letras y centavos) sin indentación
      doc.text(`${importeEnLetras} CON ${centavos.toString().padStart(2, '0')}/100`, leftMargin, yEmpresa);
      yEmpresa += lineHeight * 2;

      // Título de Forma de Pago y Autorización en la misma línea
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('FORMA DE PAGO:', leftMargin, yEmpresa);
      doc.text('AUTORIZACIÓN:', pageWidth/2 + 10, yEmpresa);
      yEmpresa += lineHeight;

      // Líneas debajo de los títulos
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, 100, yEmpresa); // Solo línea para Forma de Pago
      doc.line(pageWidth/2 + 10, yEmpresa, rightMargin, yEmpresa); // Solo línea para el título de Autorización
      yEmpresa += lineHeight;

      // Headers de ambas secciones
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      // Headers Forma de Pago
      doc.text('Fecha Pago', leftMargin, yEmpresa);
      doc.text('Importe', 80, yEmpresa);
      // Headers Autorización
      doc.text('Fecha:', pageWidth/2 + 10, yEmpresa);
      
      // Verificar si hay datos de autorización
      if (data.autorizacion?.fecha) {
        doc.setFont('helvetica', 'normal');
        doc.text(data.autorizacion.fecha, pageWidth/2 + 40, yEmpresa);
      } else {
        doc.setFont('helvetica', 'normal');
        doc.text('SIN AUTORIZACIÓN', pageWidth/2 + 40, yEmpresa);
      }
      yEmpresa += lineHeight;

      // Línea solo debajo de los headers de Forma de Pago
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, 100, yEmpresa);
      yEmpresa += lineHeight;

      // Inicializar posición Y para formas de pago y autorización
      let yFormaPago = yEmpresa;
      let yAutorizacion = yEmpresa - lineHeight;

      // Formas de pago
      doc.setFont('helvetica', 'normal');
      let totalFormaPago = 0;

      data.formasPago.forEach(fp => {
        doc.text(`${fp.fecha_pago}`, leftMargin, yFormaPago);
        const importe = fp.importe || 0;
        totalFormaPago += importe;
        const importeText = `$ ${formatNumber(importe)}`;
        doc.text(importeText, 100, yFormaPago, { align: 'right' });
        yFormaPago += lineHeight;
      });

      // Datos de Autorización
      if (data.autorizacion) {
        doc.setFont('helvetica', 'bold');
        doc.text('Usuario:', pageWidth/2 + 10, yAutorizacion);
        doc.setFont('helvetica', 'normal');
        doc.text(data.autorizacion.identificacion || '', pageWidth/2 + 40, yAutorizacion);
        yAutorizacion += lineHeight;

        doc.setFont('helvetica', 'bold');
        doc.text('Email:', pageWidth/2 + 10, yAutorizacion);
        doc.setFont('helvetica', 'normal');
        doc.text(data.autorizacion.mail || '', pageWidth/2 + 40, yAutorizacion);
        yAutorizacion += lineHeight;
      }

      // Usar el mayor valor de Y para continuar
      yEmpresa = Math.max(yFormaPago, yAutorizacion - lineHeight);

      // Línea final y total de Forma de Pago
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, 100, yEmpresa);
      yEmpresa += lineHeight;

      doc.setFont('helvetica', 'bold');
      doc.text('Total:', leftMargin, yEmpresa);
      const totalFormaPagoText = `$ ${formatNumber(totalFormaPago)}`;
      doc.text(totalFormaPagoText, 100, yEmpresa, { align: 'right' });
      
      // Línea final de Autorización (un espacio más abajo que antes)
      doc.line(pageWidth/2 + 10, yEmpresa - lineHeight, rightMargin, yEmpresa - lineHeight);

      yEmpresa += lineHeight * 2;  // Espacio adicional antes de Observaciones

      // Título de Observaciones
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('OBSERVACIONES:', leftMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Línea debajo del título
     // doc.setLineWidth(0.2);
     // doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);
     // yEmpresa += lineHeight;

      // Contenido de las observaciones
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      const observacion = data.comprobante[0]?.observacion || '';

       //Dividir el texto en múltiples líneas si es necesario
       const maxWidth = rightMargin - leftMargin;
       const splitText = doc.splitTextToSize(observacion, maxWidth);

      // Imprimir cada línea de la observación
      console.log('splitText',splitText,observacion);
      splitText.forEach((line: string) => {
        doc.text(line, leftMargin, yEmpresa);
        yEmpresa += lineHeight;
      });

      // Línea final después de las observaciones
      //doc.setLineWidth(0.2);
      //doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);

      // Usar el primer comprobante del array de forma segura
      const nombreArchivo = `OC-${data.comprobante[0]?.nro_comprobante || 'sin_numero'}.pdf`;
      doc.save(nombreArchivo);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h3>Nº {data.comprobante[0]?.nro_comprobante || ''}</h3>
      </div>
      <Space>
        <Button 
          onClick={exportToPDF}
          loading={loading || isLoading}
          disabled={loading || isLoading}
        >
          Exportar a PDF
        </Button>
      </Space>
    </div>
  );
};

export default ImprimirOCompra; 